import PropTypes from 'prop-types'
import { FeaturedGuideCard } from 'components/card'
import Link from 'components/link'

const LinkCard = ({ imageUrl, linkUrl, title, teaser }) => {
  let guideLabel = ''
  let bgColor = 'forest'

  return (
    <Link url={linkUrl} routerVersion={4} newWindow>
      <FeaturedGuideCard
        bgColor={bgColor}
        guideLabel={guideLabel}
        imageUrl={imageUrl}
        teaser={teaser}
        title={title}
      />
    </Link>
  )
}

LinkCard.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  teaser: PropTypes.string,
}

LinkCard.defaultProps = {
  teaser: null,
}

export default LinkCard
